













































import { computed, defineComponent, PropType, ref, toRefs } from '@vue/composition-api';
import DropdownPanel from '@/components/common/dropdown-panel/index.vue';
import SelectNoDataIcon from '@tt4b/ttam-assets/src/svgs/select-no-data.svg';
import ListItem from './list-item.vue';
import { IdentityFullInfo } from '../types';
import { IdentityInfo, AvatarIcon } from '@tt4b/ttam-enums';
import { useIdentityAvatarUrl } from '../hooks';
import List from './list.vue';
/**
 * custom identity 不要使用此组件
 * 不支持分页 不要使用此组件
 */
const name = 'ttam-identity-common-tiktok-list';
export default defineComponent({
  name,
  components: {
    List,
    DropdownPanel,
    SelectNoDataIcon,
  },
  props: {
    isSupportBCNvN: {
      type: Boolean,
      default: false,
    },
    type: {
      required: true,
      type: Number,
      default: 2,
    },
    listData: {
      type: Object,
      default: () => ({
        list: [],
        ttbaList: [],
        ttbcList: [],
        page: 1,
        hasMore: true,
        cursor: 0,
      }),
    },
    value: {
      type: String,
      default: '',
    },
    curItem: {
      type: Object as PropType<IdentityInfo>,
      default: () => ({
        displayName: '',
        avatarIcon: {
          width: 20,
          height: 20,
          webUri: '',
          url: '',
        },
        identityId: '',
        identityBcId: '',
      }),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    isEmpty: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    genListOptionsFunction: {
      type: Function,
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default: () => {},
    },
  },
  setup(props, { emit, slots }) {
    const { curItem, disabled } = toRefs(props);
    const popperVisible = ref(false);

    const curName = computed(() => curItem.value?.displayName ?? curItem.value?.identityId);
    const curAvatar = computed(() => useIdentityAvatarUrl(curItem.value?.avatarIcon as AvatarIcon));

    const onClick = (val: IdentityFullInfo) => {
      emit('change', val);
      popperVisible.value = false;
    };

    // 向外提供方法触发展开下拉
    const onFocus = () => {
      popperVisible.value = true;
    };

    const onAuthorizeBA = () => {
      emit('authorizeBA');
    };

    const onPopoverCTA = (val: IdentityFullInfo) => {
      emit('popover-click', val);
    };
    const toggleVisible = () => {
      if (disabled.value) {
        return;
      }
      popperVisible.value = !popperVisible.value;
    };
    return {
      name,
      curName,
      curAvatar,
      popperVisible,

      ListItem,

      onAuthorizeBA,
      onClick,
      onFocus,
      onPopoverCTA,
      toggleVisible,
    };
  },
});
